import script from "./SidenavList.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavList.vue?vue&type=script&setup=true&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=349a12ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-349a12ec"]])

export default __exports__